import React, { useEffect, useState, useContext } from 'react';

import { AppContext } from 'App';

// import Stepper from "../common/Stepper";
import StepsHeader from '../../../home/components/functional/steps-header/steps.component';

import { MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE } from '../../../home/common/constants/constants';

import {
  scrollToTop,
  navigateTo,
  getFromSessionStorage,
  googleOrderPixel,
  facebookSmbLead,
  findParamFromUrl,
  removeUserSessionData,
  thankYouPageGtags
} from '../../../common/utils/app.utils';

// import "../common/stepper.scss";
import '../common/common.scss';
import './thanks.scss';
import checkCircle from '../images/checkCircle.svg';
import vpn from '../images/vpn.png';
import plan from '../images/plan.png';
import ReferBusiness from '../referBusiness/referBusiness';

import {
  faOnDedicatedAuthThanksPageLoad,
  faOnDedicatedUnauthThanksPageLoad,
  faOnDedicatedAuthThanksPageLoadViaSummary,
  faOnDedicatedAuthThanksPageLoadViaChosePlan
} from '../../../dedicated/services/analytics.service';

import appConfig from '../../../config/config';

import DedicatedPlanPage from '../choose-plan/Plan';

import { trackMOEEvent } from '../../../common/services/moengage.service';

import { MOENGAGE_ANALYTICS_EVENT, PRODUCT_NAME, PRODUCT_TYPE, isAOIOrder } from '../../../common/constants/app.constants';

import Button from 'b2b-ui-components-lib/lib/components/button';

import ThankYouAuthPage from './ThankYouAuthPage';
import { redirectToTMODashboard } from 'home/view/manage-feasibility/utils/multiSite-utils';

const Thanks = (props) => {
  const partyId = findParamFromUrl('partyId', false);

  let {
    userType,
    leadId,
    noNetwork,
    hideNetworkSteps,
    via,
    isMultiSite = false,
    isThankYouAuth = false
  } = props && props.location && props.location.state ? props.location.state : props;

  let showNoNetwork = noNetwork ? true : false;

  let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);

  const { showSteps, setToast } = useContext(AppContext);

  const [showsubmitSuccess, setshowsubmitSuccess] = useState(false);
  const [productCheck, setProductCheck] = useState(getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? PRODUCT_TYPE.VPN : 'Dedicated Internet');

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  useEffect(() => {
    showSteps(false);
    toggelToastPopup();
    scrollToTop();
    if (leadId) {
      if (props && props.isUnAuthJourney) {
        faOnDedicatedUnauthThanksPageLoad(leadId);
        trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_THANK_YOU_PAGE_VISIT);
      } else {
        switch (via) {
          case 'SUMMARY': {
            faOnDedicatedAuthThanksPageLoadViaSummary(leadId);
            break;
          }
          case 'CHOOSE_PLAN': {
            faOnDedicatedAuthThanksPageLoadViaChosePlan(leadId);
            break;
          }
          default: {
            faOnDedicatedAuthThanksPageLoad(leadId);
            break;
          }
        }
      }
      googleOrderPixel();
      facebookSmbLead('Purchase');
    }
    if (getFromSessionStorage(MODULE_ID, PRODUCT_NAME) !== PRODUCT_TYPE.VPN) {
      thankYouPageGtags();
    }
  }, []);

  useEffect(() => {
    return () => {
      if (props && props.isUnAuthJourney) {
        navigateTo(appConfig.dedicatedhomePageUrl);
      } else {
        navigateTo(appConfig.aehdashboardUrl);
      }
    };
  }, []);

  useEffect(() => {
    setProductCheck(getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? PRODUCT_TYPE.VPN : isAOIOrder() ? 'Airtel Office Internet' : 'Airtel Office Internet');
    removeUserSessionData();
  }, []);

  if (isThankYouAuth) {
    return <ThankYouAuthPage {...props} />;
  }

  return (
    <div className="main-controller thanks-page">
      {/* <Stepper /> */}
      {showNoNetwork || hideNetworkSteps ? (
        <div className="container-old">
          <div className="plan-steps">&nbsp;</div>
        </div>
      ) : (
        <StepsHeader isdedicatedJourney={true} skipNetworkstatus={true} />
      )}
      <section className="thanks-section">
        {showsubmitSuccess && (
          <div className="network-coverage">
            <div className="coverageContent greenshade">
              <div className="checkIcon">
                <i className="material-icons">check_circle</i>
              </div>
              <p>
                <span>Thank you for sharing a business reference.</span> We will be contacting the referred person soon. Please share any other reference if you have.
              </p>
              <div className="crossIcon">
                <i className="material-icons">clear</i>
              </div>
            </div>
          </div>
        )}
        {showNoNetwork ? (
          <React.Fragment>
            <div className="container-old">
              <div className="head-area">
                <div className="thanks-heading">
                  <h3 className="danger-text">
                    Sorry! <br />
                    No network in the area.
                  </h3>
                </div>
                <p>Corporate {productCheck} Plan is not available in your area. For any queries, write to us at airtelforbusiness@airtel.com.</p>
                <p>
                  Booking order number: <strong>{leadId}</strong>
                </p>
              </div>
              <p>&nbsp;</p>
              <div className="buttonSection">
                <a className="track-link" href={redirectToTMODashboard()}>
                  Track Request
                </a>
                &nbsp;&nbsp;
                <a href={appConfig.aehdashboardUrl}>
                  <Button> Back to Home</Button>
                </a>
              </div>
            </div>
            <div className="container-old">
              <ReferBusiness showsubmitSuccess={showsubmitSuccess} setshowsubmitSuccess={setshowsubmitSuccess} isdedicatedJourney={true} />
              <div className="box-content">
                <h6>Check some other offers we have to serve you.</h6>
                <div className="row">
                  <div className="flg-lg-6 flg-md-12">
                    <div className="card">
                      <div className="left-text">
                        <h4>VPN </h4>
                        <p>Ensure your company's work stays private and protected at all times with MPLS solution</p>
                        <div className="more-link">
                          <span>
                            <a target="_blank" href="https://www.airtel.in/business/b2b/airtel-vpn">
                              Know More
                            </a>
                          </span>
                        </div>
                      </div>
                      <figure className="image">
                        <img src={vpn} alt="VPN" />
                      </figure>
                    </div>
                  </div>
                  <div className="flg-lg-6 flg-md-12">
                    <div className="card">
                      <div className="left-text">
                        <h4>Airtel Corporate Postpaid Plans</h4>
                        <p>Give your people the best mobile plan and business-grade service to collaborate on the go, seamlessly.</p>
                        <div className="more-link">
                          <span>
                            <a target="_blank" href="https://www.airtel.in/business/b2b/postpaid-with-g-suite">
                              Know More
                            </a>
                          </span>
                        </div>
                      </div>
                      <figure className="image">
                        <img src={plan} alt="Airtel Plan" />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="container-old">
            <div className="row">
              <div className="flg-lg-7 flg-md-12">
                <div className="thanks-content">
                  <div className="head-title">
                    <img src={checkCircle} alt="Checked" />

                    {userType === 'KAM' ? (
                      <h2>
                        Thank you! <br /> Request approved successfully.
                      </h2>
                    ) : (
                      <h2>Thank you for choosing Airtel! Request raised successfully.</h2>
                    )}
                  </div>
                  {userType === 'KAM' ? (
                    <p>
                      Your booking order for the Airtel {productCheck} Plan has been approved. An e-mail has been sent to customer along with the pricing quotation. Booking order
                      number:
                      <strong>{leadId}</strong>
                    </p>
                  ) : userType === 'ENTERPRISE' ? (
                    <p>
                      Your booking order for the {isMultiSite ? 'multiple' : ''} Airtel {productCheck} has been submitted. An e-mail has been sent to you along with the pricing
                      quotation. Booking order number: <strong>{leadId}.</strong>
                    </p>
                  ) : (
                    <p>
                      Your booking order for the {isMultiSite ? 'multiple' : ''} {productCheck} Plan has been submitted. An e-mail has been sent to you along with the pricing
                      quotation. {leadId ? 'Booking order number: ' + leadId : ''}
                    </p>
                  )}
                </div>
                <p>&nbsp;</p>
                <div className="buttonSection">
                  {userType !== 'ENTERPRISE' && (
                    <a className="track-link" href={redirectToTMODashboard()}>
                      Track Request
                    </a>
                  )}
                  &nbsp;&nbsp;
                  <a href={appConfig.aehdashboardUrl}>
                    <Button> Back to Home</Button>
                  </a>
                </div>
              </div>
              {userType === 'KAM' ? (
                <div className="flg-lg-5 flg-md-12"></div>
              ) : (
                <div className="flg-lg-5 flg-md-12">
                  <div className="other-steps">
                    <h3>Next Steps</h3>
                    <ul className="steps-items">
                      {props && props.isUnAuthJourney ? (
                        <li>
                          <h4>Expect a Call</h4>
                          <p>Our Sales representative will call you to book an appointment with you.</p>
                        </li>
                      ) : userType !== 'ENTERPRISE' ? (
                        <li>
                          <h4>KYC Verification</h4>
                          <p>As per TRAI regulations, our representative will fill your company details, take a photo of your company GSTN/PAN, POI and click your live photo.</p>
                        </li>
                      ) : (
                        <li>
                          <h4>Order Verification</h4>
                          <p>Our order verification team will process and verify the order details. We will notify you once the order is confirmed.</p>
                        </li>
                      )}
                      <li>
                        <h4>{isAOIOrder() ? 'Airtel Office Internet' : productCheck} Installation</h4>
                        <p>Post successful verification, internet service will be installed, activated and ready to use.</p>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {leadId !== 'KAM' && <ReferBusiness showsubmitSuccess={showsubmitSuccess} setshowsubmitSuccess={setshowsubmitSuccess} isdedicatedJourney={true} />}
            <div className="box-content">
              <h6>Check some other offers we have to serve you.</h6>
              <div className="row">
                <div className="flg-lg-6 flg-md-12">
                  <div className="card">
                    <div className="left-text">
                      <h4>VPN </h4>
                      <p>Ensure your company's work stays private and protected at all times with MPLS solution</p>
                      <div className="more-link">
                        <span>
                          <a target="_blank" href="https://www.airtel.in/business/b2b/airtel-vpn">
                            Know More
                          </a>
                        </span>
                      </div>
                    </div>
                    <figure className="image">
                      <img src={vpn} alt="VPN" />
                    </figure>
                  </div>
                </div>
                <div className="flg-lg-6 flg-md-12">
                  <div className="card">
                    <div className="left-text">
                      <h4>Airtel Corporate Postpaid Plans</h4>
                      <p>Give your people the best mobile plan and business-grade service to collaborate on the go, seamlessly.</p>
                      <div className="more-link">
                        <span>
                          <a target="_blank" href="https://www.airtel.in/business/b2b/postpaid-with-g-suite">
                            Know More
                          </a>
                        </span>
                      </div>
                    </div>
                    <figure className="image">
                      <img src={plan} alt="Airtel Plan" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default Thanks;
